import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useIsAuthenticated} from '../../../features/Authentication/hooks/useIsAuthenticated';
import {useIsCoinsActive} from '../../../features/Coins/utils/useIsCoinsActive';
import {useGetCoins} from '../utils/useGetCoins';
import {CoinsRefresh} from './CoinsRefresh';
import {HeaderCoinsWalletButtonView} from './HeaderCoinsWalletButtonView';

export const HeaderCoinsWalletButton: React.FC = () => {
  const isCoinsActive = useIsCoinsActive();
  const {isAuthenticated} = useIsAuthenticated();

  if (!isCoinsActive || !isAuthenticated) {
    return null;
  }

  return <HeaderCoinsWalletButtonFetcher />;
};

const HeaderCoinsWalletButtonFetcher: React.FC = () => (
  <>
    <CoinsRefresh />
    <DataFetcher
      request={useGetCoins()}
      // If the request fails, we still want to display the coins entry button.
      Error={() => <HeaderCoinsWalletButtonView />}
      Loading={undefined}
      View={HeaderCoinsWalletButtonView}
    />
  </>
);
